import { EOrderDateType } from '../types/order'

export const DATE_FORMAT = 'DD/MM/YYYY, HH:mm:ss'
export const DATE_FORMAT_INTERNATIONAL = 'YYYY-MM-DD'
export const DATE_FORMAT_FULL = 'DD MMMM YYYY'
export const ONLY_DATE_FORMAT = 'DD/MM/YYYY'
export const ONLY_DATE_TIME_FORMAT = 'DD/MM/YYYY HH:mm'
export const ONLY_TIME_FORMAT = 'HH:mm'
export const ONLY_MONTH_FORMAT = 'MM/YYYY'
export const TIME_FORMAT = 'HH:mm:ss'
export const MONEY_FORMAT = '0,0.00[00]'
export const NUMBER_FORMAT = '0,0.[00]'
export const COUNT_FORMAT = '0,0'

export const FACEBOOK_MESSAGE_EVENT = 'facebook:message'

export enum SortEnum {
  DESC = 'desc',
  ASC = 'asc',
}

export const MAX_DONWLOAD_PAGE_SIZE = 100

export enum VAT_TYPES {
  EXCLUDE = 'exclude',
  INCLUDE = 'include',
  NON_VAT = 'non-vat',
}
export const ACTION_TYPE_TITLES: Record<string, string> = {
  CREATE: 'สร้างคำสั่งซื้อ',
  UPDATE: 'แก้ไข',
  DELETE: 'ยกเลิก/ลบ',
  OPEN_TRACKING: 'สร้างหมายเลขพัสดุ',
  CANCEL_TRACKING: 'ยกเลิกหมายเลขพัสดุ',
  PRINT_LABEL: 'พิมพ์ใบลาเบล',
  ADD_ITEMS: 'เพิ่มสินค้า',
  REMOVE_ITEMS: 'ลบสินค้า',
  UPDATE_DISCOUNT: 'แก้ไขส่วนลด',
  CHANGE_STATUS: 'เปลี่ยนสถานะ',
}

export const DATE_TYPES = [
  {
    label: 'วันที่คำสั่งซื้อ',
    value: EOrderDateType.ORDERDATE,
  },
  {
    label: 'วันที่สร้างคำสั่งซื้อ',
    value: EOrderDateType.CREATED,
  },
  {
    label: 'วันที่ขนส่งรับสินค้า',
    value: EOrderDateType.PICKUP,
  },
  {
    label: 'วันที่พิมพ์',
    value: EOrderDateType.PRINTED,
  },
  {
    label: 'วันที่สถานะเลขพัสดุ',
    value: EOrderDateType.TRACKING,
  },
]

export const LAST_PRODUCT_STORE = 'last_product'
